<template>
  <v-container fluid :class="containerStyles">
    <form>
      <h2>Please provide the attachments below</h2>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isIDorPassPort" readonly/>
        <span>National Identity Card / Passport</span>
        <v-spacer/>
        <v-tooltip v-if="isIDorPassPort" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.national_id" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            A National Identity Card is a government provided document or informative
            plasticized card, to verify citizenship of an individual, in absence of it
            one can provide a passport( a document to show personal information
            and allows cross of county borders, issued by the government).
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isIDorPassPort"
            color="primary"
            x-small
            @click="openDialog('national_id')"
        >
          <v-icon v-if="!isIDorPassPort" size="20">mdi-plus</v-icon>
          {{ isIDorPassPort ? "Update" : "Add" }}
        </v-btn>
      </div>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isAcademicCerts" readonly/>
        <span>Academic Qualification Papers </span>
        <v-spacer/>
        <v-tooltip v-if="isAcademicCerts" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.academic_levels_certificate" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            This documents certify completion of one's study in a particular field or subject,
            a University award(Transcript) is recommended.
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isAcademicCerts"
            color="primary"
            x-small
            @click="openDialog('academic_levels_certificate')"
        >
          <v-icon v-if="!isAcademicCerts" size="20">mdi-plus</v-icon>
          {{ isAcademicCerts ? "Update" : "Add" }}
        </v-btn>
      </div>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isRegistrationCert" readonly/>
        <span>Certificate of Registration</span>
        <v-spacer/>
        <v-tooltip v-if="isRegistrationCert" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.certificate_of_registration" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            This document guarantees one's qualifications and abilities as a Teacher/Mentor in a
            particular subject(s), issued by the Ministry of Education or the Board rensponsible
            of Education in one's Country of residence.
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isRegistrationCert"
            color="primary"
            x-small
            @click="openDialog('certificate_of_registration')"
        >
          <v-icon v-if="!isRegistrationCert" size="20">mdi-plus</v-icon>
          {{ isRegistrationCert ? "Update" : "Add" }}
        </v-btn>
      </div>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isConductCert" readonly/>
        <span>Certificate of  Conduct</span>
        <v-spacer/>
        <v-tooltip v-if="isConductCert" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.certificate_of_conduct" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            This document is issued by one's current or previos places of employment, to
            verifys that one (has been)/is of good behaviour, relationship at their workplace,
            and of no hinderance to the progress of the issuing institution.
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isConductCert"
            color="primary"
            x-small
            @click="openDialog('certificate_of_conduct')"
        >
          <v-icon v-if="!isConductCert" size="20">mdi-plus</v-icon>
          {{ isConductCert ? "Update" : "Add" }}
        </v-btn>
      </div>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isComputerCert" readonly/>
        <span>Certificate in Computer Applications</span>
        <v-spacer/>
        <v-tooltip v-if="isComputerCert" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.computer_certificate" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            This is any certificate or document that verifies one's additional skills
            in computer usage, as the activities to be carried on Guiomentor are completely computer based.
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isComputerCert"
            color="primary"
            x-small
            @click="openDialog('computer_certificate')"
        >
          <v-icon v-if="!isComputerCert" size="20">mdi-plus</v-icon>
          {{ isComputerCert ? "Update" : "Add" }}
        </v-btn>
      </div>
      <div class="d-flex flex-row justify-space-between align-center">
        <v-checkbox v-model="isCv" readonly/>
        <span>Curriculum Vitae</span>
        <v-spacer/>
        <v-tooltip v-if="isCv" bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <a :href="user.profile.cv" class="text-decoration-none" target="_blank">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                  small
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
          <span>Preview in new tab</span>
        </v-tooltip>
        <v-tooltip bottom color="primary" max-width="25vw">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-3"
                color="primary"
                dark
                small
            >
              mdi-information
            </v-icon>
          </template>
          <span>
            This document showcases one's academic and professional accomplishments,
            such as education, research, work experience, publications, presentations
            and any other relevant accomplishments.
          </span>
        </v-tooltip>
        <v-btn
            :outlined="isCv"
            color="primary"
            x-small
            @click="openDialog('cv')"
        >
          <v-icon v-if="!isCv" size="20">mdi-plus</v-icon>
          {{ isCv ? "Update" : "Add" }}
        </v-btn>
      </div>
      <v-row v-if="isOnOnboardingPage">
        <v-col class="d-flex flex-row justify-space-between mt-2" cols="12">
          <div class="d-flex flex-row">
            <v-btn
                :disabled="loading"
                class="elevetion-0"
                color="primary"
                width="15%"
                @click="handleClickBack()"
            >Back
            </v-btn>
            <v-btn
                :disabled="loading"
                class="elevetion-0 ml-4"
                color="primary"
                width="15%"
                @click="handleClickSkip()"
            >Skip
            </v-btn>
          </div>
          <v-btn
              :disabled="!formValid || loading"
              :loading="loading"
              color="primary"
              width="45%"
              @click="handleClickNext()"
          >Next
          </v-btn>
        </v-col>
      </v-row>
    </form>
    <UploadDialog
        :dialog="showUploadDialog"
        :field-name="fieldName"
        :multiple="multiple"
        @onClose="showUploadDialog = false"
        @onFilesUploaded="handleFilesUploaded($event)"
    />
  </v-container>
</template>

<script>
import UploadDialog from "@/components/UploadDialog.vue";
import {mapGetters, mapMutations} from "vuex";

export default {
  components: {UploadDialog},
  props: {
    isOnOnboardingPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      showUploadDialog: false,
      multiple: false,
      fieldName: "",
      containerStyles: this.isOnOnboardingPage ? 'd-flex flex-column justify-center mt-5' : 'd-flex flex-column justify-center'
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
    }),
    isIDorPassPort() {
      return !!this.user.profile.national_id
    },
    isAcademicCerts() {
      return !!this.user.profile.academic_levels_certificate
    },
    isRegistrationCert() {
      return !!this.user.profile.certificate_of_registration
    },
    isConductCert() {
      return !!this.user.profile.certificate_of_conduct
    },
    isComputerCert() {
      return !!this.user.profile.computer_certificate
    },
    isCv() {
      return !!this.user.profile.cv
    },
    formValid() {
      const {isIDorPassPort, isAcademicCerts, isRegistrationCert, isConductCert, isComputerCert, isCv} = this
      return !!(isIDorPassPort && isAcademicCerts && isRegistrationCert && isConductCert && isComputerCert && isCv);
    }
  },
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      setProfile: "auth/SET_USER_PROFILE"
    }),

    openDialog(value) {
      this.showUploadDialog = true
      this.fieldName = value
    },

    handleFilesUploaded(res) {
      this.setAuthSuccess({...this.user, profile: {...this.user.profile, ...res}});
      this.setProfile({...this.profile, ...res});
    },

    handleClickBack() {
      this.$emit('handleClickBack')
    },

    handleClickNext() {
      this.$emit('handleClickNext');
      this.$snackbar.showMessage({
        content: this.$t("profile.edit.updatedSuccess"),
        color: "success"
      });
    },
    handleClickSkip() {
      this.$emit('handleClickSkip');
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.v-btn {
  text-transform: none !important;
}

.form {
  background: #ffffff;
  min-height: 400px;
  width: 100%;
  margin: 0 auto;
  border-radius: 20px;
  padding: 20px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100%;
  }
}
</style>
